import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum SalesCaseStageId {
  LEAD = 'lead',
  DEAL = 'deal',
  OFFER = 'offer',
  IMPLEMENTATION = 'implementation',
  FINISHED = 'finished',
}

export class SalesCaseStage extends Codebook<SalesCaseStageId> {
  static readonly LEAD = new SalesCaseStage(SalesCaseStageId.LEAD, () => $t('Lead'), 'bullseye')

  static readonly DEAL = new SalesCaseStage(
    SalesCaseStageId.DEAL,
    () => $t('Deal'),
    'handshake-angle',
  )

  static readonly FINISHED = new SalesCaseStage(
    SalesCaseStageId.FINISHED,
    () => $t('Finished'),
    'building-circle-check',
  )
  static readonly OFFER = new SalesCaseStage(
    SalesCaseStageId.OFFER,
    () => $t('Offer'),
    'hand-holding-dollar',
  )
  static readonly IMPLEMENTATION = new SalesCaseStage(
    SalesCaseStageId.IMPLEMENTATION,
    () => $t('Implementation'),
    'screwdriver-wrench',
  )

  private constructor(
    id: SalesCaseStageId,
    public readonly name: () => string,
    public readonly icon: string,
  ) {
    super(id)
  }
}
